import React from 'react';
import { GraduationCap, Calendar, MapPin, Award } from 'lucide-react';
import { portfolioData } from '../data/portfolioData';

export const Education: React.FC = () => {
  return (
    <section id="education" className="section education-section">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">
            <GraduationCap size={14} />
            <span>Academic Background</span>
          </div>
          <h2 className="section-title">
            Education & <span className="text-gradient">Qualifications</span>
          </h2>
          <p className="section-subtitle">
            Solid computer science foundation in information technology and software engineering principles.
          </p>
        </div>

        <div className="education-grid">
          {portfolioData.educations.map((edu, index) => (
            <div key={index} className="edu-card glass-card">
              <div className="edu-icon-badge">
                <Award size={24} />
              </div>

              <div className="edu-content">
                <h3 className="edu-title">{edu.title}</h3>
                <div className="edu-institute">{edu.institute}</div>

                <div className="edu-meta">
                  <span>
                    <Calendar size={14} /> {edu.startDate} - {edu.endDate}
                  </span>
                  <span>
                    <MapPin size={14} /> {edu.state}
                  </span>
                </div>

                <p className="edu-desc">{edu.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .education-section {
          background: var(--bg-primary);
          padding-top: 1.5rem;
        }

        .education-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
          gap: 2rem;
          max-width: 960px;
          margin: 0 auto;
        }

        .edu-card {
          padding: 2rem;
          display: flex;
          gap: 1.5rem;
          align-items: flex-start;
        }

        .edu-icon-badge {
          width: 50px;
          height: 50px;
          border-radius: var(--radius-md);
          background: var(--gradient-brand);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          box-shadow: var(--shadow-glow);
        }

        .edu-content {
          display: flex;
          flex-direction: column;
        }

        .edu-title {
          font-size: 1.25rem;
          font-weight: 700;
          color: var(--text-main);
          margin-bottom: 0.35rem;
          line-height: 1.35;
        }

        .edu-institute {
          font-size: 1rem;
          color: var(--accent-primary);
          font-weight: 600;
          margin-bottom: 0.75rem;
        }

        .edu-meta {
          display: flex;
          gap: 1rem;
          font-size: 0.85rem;
          color: var(--text-muted);
          margin-bottom: 1rem;
          flex-wrap: wrap;
        }

        .edu-meta span {
          display: flex;
          align-items: center;
          gap: 0.35rem;
        }

        .edu-desc {
          font-size: 0.95rem;
          color: var(--text-muted);
          line-height: 1.6;
        }

        @media (max-width: 576px) {
          .edu-card {
            flex-direction: column;
          }
        }
      `}</style>
    </section>
  );
};
